//导出（公共）
import {postBlob} from "@/plugins/axios";
import Vue from 'vue'

// 查询：生成的下载文件
export function getDownloadFileList(data) {
    return Vue.axios({
        url: '/api/download_file/list',
        method: 'post',
        data: {...data,}

    })
}

// 创建：生成的下载文件
export function createDownloadFileList(data) {
    return Vue.axios({
        url: '/api/download_file/create',
        method: 'post',
        data: {...data,}

    })
}

//导出：已生成的下载文件
export function downloadFileExport(data) {
    return postBlob('/api/download_file/export', data)
}

//下载文件
export function downloadByFileId(data={id:0}) {
    return postBlob('/api/download_file/downByFileId', data)
}

// 删除：生成的下载文件
export function deleteDownloadFile(data) {
    return Vue.axios({
        url: '/api/download_file/delete',
        method: 'post',
        data: {...data,}

    })
}